import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  leaveTypes: [],
  selectedLeaveType: null,
};

const leaveTypeSlice = createSlice({
  name: "companyLeaveType",
  initialState,
  reducers: {
    // Get Leave Types
    getLeaveTypesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getLeaveTypesSuccess: (state, action) => {
      state.loading = false;
      state.leaveTypes = action.payload;
      state.error = null;
    },
    getLeaveTypesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Leave Type
    createLeaveTypeStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createLeaveTypeSuccess: (state, action) => {
      state.loading = false;
      state.leaveTypes.push(action.payload);
      state.error = null;
    },
    createLeaveTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Status
    updateLeaveTypeStatusStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateLeaveTypeStatusSuccess: (state, action) => {
      state.loading = false;
      const index = state.leaveTypes.findIndex(
        (type) => type.id === action.payload.id,
      );
      if (index !== -1) {
        state.leaveTypes[index].status = action.payload.status;
      }
      state.error = null;
    },
    updateLeaveTypeStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Update Leave Type
    updateLeaveTypeStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateLeaveTypeSuccess: (state, action) => {
      state.loading = false;
      const index = state.leaveTypes.findIndex(
        (type) => type.id === action.payload.id,
      );
      if (index !== -1) {
        state.leaveTypes[index] = action.payload;
      }
      state.error = null;
    },
    updateLeaveTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete Leave Type
    deleteLeaveTypeStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteLeaveTypeSuccess: (state, action) => {
      state.loading = false;
      state.leaveTypes = state.leaveTypes.filter(
        (type) => type.id !== action.payload,
      );
      state.error = null;
    },
    deleteLeaveTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Leave Type
    setSelectedLeaveType: (state, action) => {
      state.selectedLeaveType = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getLeaveTypesStart,
  getLeaveTypesSuccess,
  getLeaveTypesFailure,
  createLeaveTypeStart,
  createLeaveTypeSuccess,
  createLeaveTypeFailure,
  updateLeaveTypeStatusStart,
  updateLeaveTypeStatusSuccess,
  updateLeaveTypeStatusFailure,
  updateLeaveTypeStart,
  updateLeaveTypeSuccess,
  updateLeaveTypeFailure,
  deleteLeaveTypeStart,
  deleteLeaveTypeSuccess,
  deleteLeaveTypeFailure,
  setSelectedLeaveType,
  clearError,
} = leaveTypeSlice.actions;

export default leaveTypeSlice.reducer;
